<template>
  <div class="batchAdjustPermissions">
    <!-- 批量调整权限  -->
    <div class="header">
      <div class="headerContainer">
        <el-breadcrumb>
          <!-- 组织架构 -->
          <el-breadcrumb-item>
            {{ $t("message.organizationalStructure") }}
          </el-breadcrumb-item>
          <!-- 角色列表 -->
          <el-breadcrumb-item to="roleList">
            {{ $t("message.theRoleList") }}
          </el-breadcrumb-item>
          <!-- 批量调整权限 -->
          <el-breadcrumb-item>
            {{ $t("message.batchAdjustPermissions") }}
          </el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="auth">
      <div class="menu item">
        <!--  菜单权限-->
        <div class="title">{{ $t("message.menuPermissions") }}</div>
        <div class="item-main" v-for="(item, index) in menu" :key="item.id">
          <!-- 一级 -->
          <div class="item-title">
            <el-checkbox v-model="item.checked" @change="changeMenu">
              {{ item.name }}</el-checkbox>
          </div>
          <!-- 二级 -->
          <div class="itmeChed" v-for="(items, indexs) in item.child_menus" :key="items.id">
            <div class="foxbase">
              <el-checkbox v-model="items.checked" @change="allCancel(index, indexs)">{{
                items.name }}</el-checkbox>
            </div>
            <!-- 三级 -->
            <div class="three">
              <el-checkbox v-model="itemss.checked" v-for="itemss in items.child_menus" :key="itemss.id"
                @change="setAuthMenu">{{ itemss.name
                }}</el-checkbox>
            </div>
          </div>
        </div>
      </div>
      <div class="page item">
        <!-- 操作权限 -->
        <div class="title">
          {{ $t("message.operatingAuthorization") }}
        </div>
        <div class="page-item-box" v-for="(item, index) in page" :key="index">
          <div class="item-main">
            <div class="item-title">{{ item.name }}</div>
            <div class="itmeChed">
              <el-checkbox v-model="items.checked" v-for="items in item.child_buttons" :key="items.id">
                {{ items.name }}
                {{ items.id }}
              </el-checkbox>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="btn">
      <el-button type="danger" @click="batchSetRoleAuth('remove')">
        批量取消权限
      </el-button>
      <el-button type="primary" @click="batchSetRoleAuth('add')" class="primary"
        style="margin-left: 100px">批量设置权限</el-button>
    </div>
    <!-- 角色选择 -->
    <el-dialog :title="$t('message.roleChoices')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="1088px" center>
      <div class="content">
        <div class="roleSelection">
          <el-button type="primary" class="primary" @click="allCheckedRole('all')">全选</el-button>
          <el-button type="primary" class="primary" @click="allCheckedRole(['业务', '部长', '课长'])">全部业务</el-button>
          <el-button type="primary" class="primary" @click="allCheckedRole(['采购'])">全部采购</el-button>
          <el-button type="primary" class="primary" @click="allCheckedRole(['配货'])">全部配货</el-button>
          <el-button type="primary" class="primary"
            @click="allCheckedRole(['检品', 'FBA', '缝标', '精检', '普检'])">全部检品</el-button>
          <el-button type="primary" class="fr" @click="save">保存</el-button>
        </div>
      </div>
      <!-- 角色 -->
      <div class="role">
        <div class="item" v-for="(item) in options" :key="item.id">
          <el-checkbox v-model="item.checked">{{ item.name }}</el-checkbox>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: false,
      val: '',
      options: [],
      menu: [],
      page: [],
      checked: false,
      checkAll: [],
      datas: {
        action: '',
        roleIdSet: [],
        authIdSet: [],
      },
    };
  },
  created() {
    this.$api.roleApi.roleList({ pageSize: 10000, page: 1 }).then((res) => {
      res.data.data.forEach(item => {
        item.checked = false
      })
      this.options = res.data.data;
    });
    this.allAuth();
  },
  methods: {
    // 获取权限，并添加每项勾选
    allAuth() {
      this.$api.roleApi.allAuth().then((res) => {
        this.menu = res.data.menu;
        this.page = res.data.page;
      });
    },
    // 选择菜单显示改页面权限
    setAuthMenu() {
      this.checkAll = [];
      this.menu.forEach((item) => {
        item.child_menus.forEach((items) => {
          items.child_menus.forEach((itemss) => {
            if (itemss.checked) {
              this.checkAll.push(itemss.id);
            }
          });
        });
      });
      this.$forceUpdate()
    },
    // 不选菜单 关闭底下全部权限
    changeMenu() {
      // this.menu.forEach((item) => {
      //   if (!item.checked) {
      //     item.child_menus.forEach((items) => {
      //       items.checked = false;
      //       items.child_menus.forEach((itemss) => {
      //         itemss.checked = false;
      //       });
      //     });
      //   }
      // });
      this.setAuthMenu();
    },
    // 二级菜单全取消
    allCancel(index, indexs) {
      // this.menu[index].child_menus[indexs].child_menus.forEach((item) => {
      //   item.checked = false;
      // });
      this.$forceUpdate()
    },
    //已选一级菜单，自动帮选2，3级菜单
    allChecked() {
      this.menu.forEach((item) => {
        if (item.checked) {
          item.child_menus.forEach((items) => {
            items.checked = true;
            items.child_menus.forEach((itemss) => {
              itemss.checked = true;
              // 页面权限全选
              this.page.forEach((page) => {
                page.child_buttons.forEach((pages) => {
                  pages.checked = true
                });
              });
            });
          });
        }
      });
    },
    // 批量添加或删除权限
    batchSetRoleAuth(type) {
      this.datas.action = type
      this.dialogVisible = true
    },
    //导出
    daochu() {
      let list = []
      let i = 0
      this.page.forEach(item => {
        item.child_buttons.forEach(items => {
          items.index = i
          i++
          list.push(items)
        })
      })
      this.handleExportExcel(list)
    },
    // excel导出
    handleExportExcel(list) {
      require.ensure([], () => {
        const { export_json_to_excel } = require('@/utlis/Export2Excel')
        const tHeader = ['NO', '权限名称', '权限ID']
        const filterVal = ['index', 'name', 'id']
        const data = this.formatJson(filterVal, list)
        export_json_to_excel(tHeader, data, '权限列表')
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]))
    },
    //全选
    allCheckedRole(type) {
      if (type == 'all') {
        this.options.forEach(item => {
          item.checked = true
        })
      } else {
        this.options.forEach(item => {
          item.checked = false
          type.forEach(items => {
            if (item.name.indexOf(items) != -1) {
              item.checked = true
            }
          })
        })
      }
    },
    // 保存
    save() {
      this.datas.authIdSet = []
      this.datas.roleIdSet = []
      this.menu.forEach((item) => {
        if (item.checked) {
          this.datas.authIdSet.push(item.id);
        }
        item.child_menus.forEach((items) => {
          if (items.checked) {
            this.datas.authIdSet.push(items.id);
          }
          items.child_menus.forEach((itemss) => {
            if (itemss.checked) {
              this.datas.authIdSet.push(itemss.id);
            }
          });
        });
      });
      this.page.forEach((item) => {
        item.child_buttons.forEach((items) => {
          if (items.checked) {
            this.datas.authIdSet.push(items.id);
          }
        });
      });
      this.options.forEach(item => {
        if (item.checked) {
          this.datas.roleIdSet.push(item.id)
        }
      })
      this.$confirm('请确认是否批量调整权限，确认后所有已选择得角色权限进行变更?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.$api.roleApi.batchSetRoleAuth(this.datas).then(res => {
          this.$message.success(res.msg)
          this.dialogVisible = false
          this.wipeData()
        })
      }).catch(() => {
      });
    },
    wipeData() {
      this.menu.forEach((item) => {
        item.checked = false
        item.child_menus.forEach((items) => {
          items.checked = false
          items.child_menus.forEach((itemss) => {
            itemss.checked = false
          });
        });
      });
      this.page.forEach((item) => {
        item.child_buttons.forEach((items) => {
          items.checked = false
        });
      });
      this.options.forEach(item => {
        item.checked = false

      })
      this.datas = {
        action: '',
        roleIdSet: [],
        authIdSet: [],
      }
    },

  },
};
</script>
<style lang='scss' scoped>
/deep/.el-checkbox__inner {
  transform: scale(1.5);
}

.batchAdjustPermissions {
  background-color: #f6f6f6;
  // position: relative;

  header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}

.name {
  margin: 0 0 20px;

  p {
    margin-bottom: 20px;
  }

  span {
    margin-right: 50px;
    color: #036eb8;
    cursor: pointer;
  }
}

.auth {
  display: flex;
  margin-top: 20px;

  .item-main {
    margin-bottom: 50px;
  }

  .item {
    flex: 1;
    border: 1px solid #ccc;
    padding: 20px;
    border-radius: 20px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

    .item-title {
      margin: 20px 20px 20px 0;
    }

    .itmeChed {
      margin-left: 20px;

      .el-checkbox {
        margin-bottom: 10px;
      }

      .foxbase {
        .el-checkbox {
          margin: 0 0 15px 0px;
        }
      }

      .three {
        margin-left: 25px;
        margin-bottom: 10px;
      }
    }
  }

  .menu {
    margin-right: 30px;
  }
}

.btn {
  position: sticky;
  bottom: 0;
  left: 0;
  text-align: center;
  height: 40px;
  margin: 30px 0 0;
  z-index: 1;
  background-color: #fff;
}

.role {
  display: flex;
  flex-wrap: wrap;

  .item {
    margin: 30px 30px 0 0;
  }
}
</style>